<template>
  <div>
      <v-card>
        <v-container>
          <h2 class="text-xs-center">{{$t('dashboard.chart.reorder_modal_title')}}</h2>
          <custom-text msg="custom-text.charts_reorder" class="mt-2"></custom-text>
        </v-container>
        <v-layout row>
          <v-flex xs12>
            <v-list>
              <draggable v-model="draggableGraphs" v-bind="dragOptions" class="list-group">
                <transition-group type="transition" name="flip-list">
                  <template v-for="item in graphs" :class="tableRowClass">
                    <reorder-row v-if="!item.isHidden" :graph="item" :key="item.id"></reorder-row>
                  </template>
                </transition-group>
              </draggable>
            </v-list>
          </v-flex>

        </v-layout>
        <v-card-actions>
          <v-layout row justify-center class="pt-1 pb-1">
            <v-btn id="charts-reorder-cancel-btn" @click="cancelReorder">{{$t('dashboard.chart.reorder_cancel_button')}}</v-btn>
            <v-btn id="charts-reorder-apply-btn" @click="applyReorder" color="primary">{{$t('dashboard.chart.reorder_apply_button')}}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
  </div>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  import ReorderRow from './ReorderRow'
  import draggable from 'vuedraggable'
  import CustomText from '../help/CustomText'
  import {
    REFRESH_SECONDARY_DASHBOARD_GRAPHS_SEQUENCE,
    RESET_DASHBOARD_GRAPHS_SEQUENCE,
    SET_INFORMATION_SNACKBAR_STATE, SET_INFORMATION_SNACKBAR_TEXT, SET_REORDER_CHART_DIALOG_VISIBILITY
  } from '../../store/mutation-types'
  import { UPDATE_DASHBOARD_GRAPH_SEQUENCE } from '../../store/action-types'
  import { informationTexts } from '../../store/modules/information'

  export default {
    name: 'reorder-chart-modal',
    mixins: [],
    components: {ReorderRow, draggable, CustomText},
    data () {
      return {}
    },
    methods: {
      ...mapActions({
        updateSequence: UPDATE_DASHBOARD_GRAPH_SEQUENCE
      }),
      ...mapMutations({
        setSnackBarText: SET_INFORMATION_SNACKBAR_TEXT,
        setSnackBar: SET_INFORMATION_SNACKBAR_STATE
      }),
      cancelReorder () {
        this.$store.commit(RESET_DASHBOARD_GRAPHS_SEQUENCE)
        this.$store.commit(SET_REORDER_CHART_DIALOG_VISIBILITY, false)
        this.setSnackBarText(informationTexts.CHART_REORDER_CANCELLED)
        this.setSnackBar(true)
      },
      applyReorder () {
        this.updateSequence(this.graphs)
        this.$store.commit(SET_REORDER_CHART_DIALOG_VISIBILITY, false)
      }
    },
    computed: {
      ...mapState({
        chartTypes: state => state.dashboard.availableCharts
      }),
      graphTitle () {
        let key = `dashboard.${this.graph.chartTitle}`
        if (this.$i18n.keyExists(key)) {
          return this.$t(key)
        } else {
          return this.graph.chartTitle
        }
      },
      dragOptions () {
        return {
          animation: 0,
          group: 'description',
          disabled: false,
          ghostClass: 'ghost',
          chosenClass: 'chosen'
        }
      },
      draggableGraphs: {
        get () {
          // only display non hidden (deleted) charts
          return this.graphs
        },
        set (value) {
          // concat hidden (deleted) charts to the end of newly sequenced array
          this.$store.commit(REFRESH_SECONDARY_DASHBOARD_GRAPHS_SEQUENCE, value)
        }
      }
    },
    props: {
      graphs: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style scoped>
  .filter-list-rows {
    overflow: auto;
    height: 55vh;
    max-height: calc(100vh - 340px);
    -webkit-overflow-scrolling: touch;
  }
  /* Transitions */
  .filter-list-enter-active,
  .filter-list-leave-active {
    transition: all 0.4s;
    opaque: 1;
  }

  .filter-list-enter, .filter-list-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translate(-16px, 0px)
  }
</style>

<style>
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #ededed;
  }
  .chosen {
    opacity: 1;
    background: #ededed;
  }
  .list-group {
    min-height: 20px;
  }
  .list-group-item {
    cursor: move;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/ReorderChartModal.vue